import styles from "../css/InfoBox.module.css";

const InfoBox = ({ number, title, text, isChecked }) => {
  return (
    <div
      className={styles.box}
      style={{ backgroundColor: isChecked && "#F4FFDA" }}
    >
      <div className={styles.numberBox}>{number}</div>
      <div className={styles.textBox}>
        <h3>{title}</h3>
        <p>{text}</p>
      </div>
    </div>
  );
};

export default InfoBox;
